
import { useEffect, useState } from "react"
import Topdesk from "../../API/MICROSERVICES/topdesk/topdesk";
import Tracking from "../../API/MICROSERVICES/tracking/tracking";





export default function Pruebas(props: any) {




  async function CheckVpn() {

    console.log("Ejecutando CheckVpn");

    let otro = await Tracking.DD({
      "dadjfolio": "12345",
      "odflcodigo": "259571121"
    });

    console.log("1 documento erroneo ", otro);

    let otro2 = await Tracking.DD({
      "dadjfolio": "12345",
      "odflcodigo": "25951121"
    });

    console.log("2 of no exister", otro2);

    let otro3 = await Tracking.DD({
      "dadjfolio": "329091",
      "odflcodigo": "259571121"
    });

    console.log("3 Exito", otro3);


    let usuario = await Topdesk.infoUsuarios("f62a1b13-b932-42c0-bedb-5e68980dd823");
    console.log(usuario);


  }




  useEffect(() => {

    console.log("Ejecutando useEffect");

    CheckVpn();

  }, []);




  return (
    <>
      <h1>Prueba</h1>



    </>
  )

}
